import PropTypes from 'prop-types';
import {sectionConstants} from '_app/utils';

const sectionShape = PropTypes.oneOf([
	sectionConstants.SECTION_IDS.CAMPAIGNS_ID,
	sectionConstants.SECTION_IDS.CONTENT_LIBRARY_ID,
	sectionConstants.SECTION_IDS.EMAILS_ID
]);

export default sectionShape;